import { useEffect, useState } from "react";
import Particles from "./Particles";

const SHIELD = "https://customer-assets.emergentagent.com/job_before-the-loss-1/artifacts/hyk3lwcd_514CC5D3-9081-44D7-8DD9-B78FADD7368F.png";

/**
 * Cinematic 4-second loading screen. Fades out smoothly and unmounts after the fade.
 */
export const Loader = () => {
  const [leaving, setLeaving] = useState(false);
  const [mounted, setMounted] = useState(true);

  useEffect(() => {
    // Lock scroll while loader is on screen
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const leaveT = setTimeout(() => setLeaving(true), 4000);
    const unmountT = setTimeout(() => {
      setMounted(false);
      document.body.style.overflow = prev;
    }, 4700);

    return () => {
      clearTimeout(leaveT);
      clearTimeout(unmountT);
      document.body.style.overflow = prev;
    };
  }, []);

  if (!mounted) return null;

  return (
    <div className={`btr-loader ${leaving ? "is-leaving" : ""}`} data-testid="site-loader" aria-hidden={leaving}>
      {/* Ambient beams + particles */}
      <div className="btr-beam btr-beam-drift" style={{ width: 520, height: 520, top: "-10%", right: "-10%", background: "#a2020b", opacity: 0.35 }} />
      <div className="btr-beam btr-beam-drift" style={{ width: 420, height: 420, bottom: "-10%", left: "-10%", background: "#a2020b", opacity: 0.18, animationDelay: "2s" }} />
      <div className="absolute inset-0 btr-grid-animated opacity-20 pointer-events-none" />
      <Particles count={12} />

      {/* Shield + rotating rings */}
      <div className="btr-loader-shield-wrap">
        <div className="btr-loader-ring" />
        <div className="btr-loader-ring reverse" />
        <img src={SHIELD} alt="Before The Risk" className="btr-loader-shield" />
      </div>

      <div className="btr-loader-bar">
        <span />
      </div>
    </div>
  );
};
